import useUsers from './users.hook'
import dashbordStore from '../store/dashbord'

export const defaultSettings = {
  sort: {
    name: 'Срочные наверх',
    _default: ['isUrgent:desc', 'id:desc']
  },
  groupView: false,
  favoriteUserIds: [],
  table: {
    user: {
      title: 'Ответственный',
      available: true,
      className: '',
      initialWidth: 16,
      width: 16,
      configurable: true,
      padding: false,
      sortPath: 'user.username',
      hideOnService: true,

    },
    title: {
      available: true,
      title: 'Назв-е товара',
      configurable: true,
      initialWidth: 21.7,
      width: 21.7,
      className: 'text-Regular(14_16)',
      sortPath: 'position.title',
    },
    code: {
      available: true,
      configurable: true,
      initialWidth: 10,
      width: 10,
      title: 'Артикул',
      className: 'text-Regular(16_18) relative',
    },
    quantity: {
      available: true,
      title: 'Кол-во',
      configurable: true,
      initialWidth: 15,
      width: 15,
      className: 'text-Regular(16_18)',
      sortPath: 'position.quantity',
      public:true,
    },
    logo: {
      available: true,
      title: 'Логотип',
      configurable: true,
      className: '',
      padding: false,
      initialWidth: 10,
      width: 10
    },
    drawings: {
      available: true,
      title: 'М-д печати',
      configurable: true,
      className: '',
      padding: false,
      initialWidth: 11.5,
      width: 11.5,
    },
    drawings_time: {
      available: true,
      title: 'Время печати',
      configurable: true,
      className: '',
      padding: false,
      initialWidth: 10,
      width: 10
    },
    custom_work: {
      available: true,
      title: 'Дополнительные работы',
      configurable: true,
      className: '',
      padding: false,
      initialWidth: 10,
      width: 10
    },
    box_count: {
      available: true,
      title: 'Кол-во коробок',
      configurable: true,
      className: '',
      padding: false,
      initialWidth: 10,
      width: 10,
    },
    stamps: {
      available: true,
      title: 'Кол-во цветов.',
      configurable: true,
      className: '',
      padding: false,
      initialWidth: 10,
      width: 10,
    },
    manager: {
      available: true,
      title: 'Менеджер',
      configurable: true,
      className: '',
      padding: false,
      initialWidth: 11.3,
      width: 11.3,
      sortPath: 'position.order.manager'
    },
    order: {
      available: true,
      title: '№ зак.',
      configurable: true,
      className: '',
      initialWidth: 12.2,
      width: 12.2,
      sortPath: 'position.order.orderId',
      public:true,
    },
    company: {
      available: true,
      title: 'Заказчик',
      configurable: true,
      className: '',
      initialWidth: 11.5,
      width: 11.5,
      sortPath: 'position.order.company',
      public:true,
    },
    date: {
      available: true,
      title: 'Дата заказа',
      configurable: true,
      className: '',
      initialWidth: 11.5,
      width: 11.5,
      sortPath: 'position.order.date',
    },
    dateDashbord: {
      available: true,
      title: 'Дата прихода на дашборд',
      configurable: true,
      className: '',
      initialWidth: 11.5,
      width: 11.5,
      sortPath: 'dashbordDate'
    },
    dateReady: {
      available: true,
      title: 'Дата готовности',
      configurable: true,
      className: '',
      initialWidth: 11.5,
      width: 11.5,
      sortPath: 'position.readyDate',

    },
    status: {
      available: true,
      title: 'Статус',
      configurable: true,
      className: 'absolute right-[5rem] bg-Dominant/Dop',
      dimensional: false,
      initialWidth: 18.7,
      constant: true,
      width: 18.7,
      padding: false,
      sortPath: 'status.title'
    },
    stage: {
      available: true,
      title: 'Этап',
      configurable: true,
      className: 'absolute right-[5.3rem] bg-Dominant/Dop',
      dimensional: false,
      padding: false,
      constant: true,
      initialWidth: 18.7,
      width: 18.7,
      sortPath: 'stage.title',

    },
    Checkbox:{
      available:true
    }
  }
}

function useSettings() {
  const { saveSettings } = useUsers()
  const { settings, setSettings } = dashbordStore

  const sanitizeSettings = settings => {
    return Object.entries(settings).reduce((acc, [key, value]) => {
      if (value.configurable) {
        acc[key] = {
          available: value.available,
          width: value.width
        }
      }
      return acc
    }, {})
  }

  const mergeTableSettings = settings => {
    const table = { ...defaultSettings.table }
    Object.entries(settings?.table || {}).forEach(([key, value]) => {
      table[key].available = value.available
      table[key].width = value.width
      table[key].initialWidth = value.width
    })
    table.Checkbox.available = true
    return {
      ...settings,
      table
    }
  }

  const setInitialSettings = settings => {
    if (settings) {
      if (settings.groupView && settings.sort.custom) {
        settings.sort = defaultSettings.sort
      }
      dashbordStore.setSettings({
        ...mergeTableSettings(settings),
        favoriteUserIds: settings.favoriteUserIds || []
      })
    } else {
      dashbordStore.setSettings(defaultSettings)
    }
  }

  const setPublicSettings = () => {
    const visibleColumns = ['title', 'code','quantity', 'drawings', 'box_count', 'stamps','order', 'company', 'date', 'dateReady', 'stage'];
    const table = {...defaultSettings.table}
    Object.keys(table).forEach(x =>{
      table[x].available = visibleColumns.includes(x)
      table[x].configurable = false
    });
    dashbordStore.setSettings({
      ...defaultSettings,
      table
    })
  }

  const updateGroupView = async view => {
    const updatedSettings = {
      ...settings,
      groupView: view
    }
    await saveSettings(updatedSettings)
    dashbordStore.setSettings(mergeTableSettings(updatedSettings))
    dashbordStore.clearSelected()
  }

  const updateTableSettings = async table => {
    const updatedSettings = {
      ...settings,
      table
    }
    await saveSettings(updatedSettings)
    dashbordStore.setSettings(mergeTableSettings(updatedSettings))
  }

  const updateSettings = async () => {
    await saveSettings(settings)
  }

  const updatePaginationLimit = async limit => {
    const updatedSettings = {
      ...settings,
      pageSize:limit
    }
    await saveSettings(updatedSettings)
    dashbordStore.setSettings(mergeTableSettings(updatedSettings))
  }

  const toggleFavoriteUser = async userId => {
    const current = dashbordStore.settings.favoriteUserIds || []
    const favoriteUserIds = current.includes(userId)
      ? current.filter(id => id !== userId)
      : [...current, userId]
    dashbordStore.setFavoriteUserIds(favoriteUserIds)
    await saveSettings({
      ...dashbordStore.settings,
      favoriteUserIds
    })
  }

  return {
    sanitizeSettings,
    mergeTableSettings,
    updateTableSettings,
    updateSettings,
    setInitialSettings,
    updateGroupView,
    updatePaginationLimit,
    setPublicSettings,
    toggleFavoriteUser
  }
}

export default useSettings
